import React, { useState, useEffect } from "react";
import "./otp.css";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, resetLogin } from "../../redux/slices/loginSlice";
import {
  generatePhoneOtpcompany,
  verifyPhoneOtp,
} from "../../redux/slices/otpSlice";
import { Login } from "iconsax-react";
import OtpInput from "react-otp-input";

const LoginScreen = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginAttempted, setLoginAttempted] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");
  const [Partnervisible, setPartnervisible] = useState(false);
  const [Companyvisible, setCompanyvisible] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(30);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [currentRoleType, setCurrentRoleType] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, loading, error } = useSelector((state) => state.adminAuth);
  const { loading: otpLoading } = useSelector((state) => state.otp);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (otpSent && timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    } else {
      setResendDisabled(false);
    }
  }, [otpSent, timer]);

  useEffect(() => {
    if (loginAttempted && user) {
      if (user.error === 0) {
        toast.success(user.msg || "Login successful!");
        localStorage.setItem("authToken", user.token);
        localStorage.setItem("user", JSON.stringify(user.user)); // Save user info
        localStorage.setItem("role_type", "admin"); // Example role type, can be dynamic
        navigate("/dashboard");
      } else if (user.error === 1) {
        toast.error(user.msg || "Invalid credentials");
        setLoginErrorMsg(user.msg || "Invalid credentials");
      }
    }
  }, [user, loginAttempted, navigate]);

  useEffect(() => {
    if (loginAttempted && error) {
      const errorMsg =
        typeof error === "string" ? error : error?.msg || "Login failed";
      toast.error(errorMsg);
      setLoginErrorMsg(errorMsg);
    }
  }, [error, loginAttempted]);

  const handleLogin = async () => {
    if (!username || !password) {
      toast.error("Please enter both username and password");
      return;
    }

    dispatch(resetLogin());
    setLoginErrorMsg("");
    setLoginAttempted(true);
    // dispatch(loginUser({ username, password }));
    const result = await dispatch(loginUser({ username, password }));
    if (loginUser.fulfilled.match(result)) {
      const response = result.payload;
      console.log("result---token-----track", response.token);
      localStorage.setItem("admintoken", response.token);
    }
    setUsername("");
    setPassword("");
  };

  const sendOTP = async (member_type) => {
    if (mobile.length !== 10) {
      toast.error("Enter a valid 10-digit mobile number.");
      return;
    }

    const result = await dispatch(
      generatePhoneOtpcompany({ phone: mobile, member_type })
    );
    if (generatePhoneOtpcompany.fulfilled.match(result)) {
      const response = result.payload;
      console.log("login ---->", response);
      if (response?.error === 0) {
        setOtpSent(true);
        setTimer(30);
        setResendDisabled(true);
        setCurrentRoleType(member_type);
        toast.success(`your otp is  ${response?.msg}`);
      } else {
        toast.error(response.msg || "Failed to send OTP");
      }
    } else {
      toast.error(result.payload || "Failed to send OTP");
    }
  };

  const verifyOTPHandler = async (redirectPath) => {
    if (otp.length !== 6) {
      toast.error("Please enter the 6-digit OTP");
      return;
    }

    const result = await dispatch(verifyPhoneOtp({ phone: mobile, otp }));
    if (verifyPhoneOtp.fulfilled.match(result)) {
      const data = result.payload;
      if (data.error === 0) {
        toast.success("OTP Verified Successfully!");

        // Clear previous login data
        localStorage.clear();
        

        // Save new login info with role type
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("user", JSON.stringify(data.user)); // Save user info
        localStorage.setItem("role_type", currentRoleType); // Save the role type

        // Navigate with role type passed in state    
        if(data.user.member_active == 0){
          navigate('/companyPage', { state: { roleType: currentRoleType } });
        }
        else{
          navigate(redirectPath, { state: { roleType: currentRoleType } });
        }
        
      } else {
        toast.error(data.msg || "Verification failed");
      }
    } else {
      toast.error(result.payload || "Verification failed");
    }
  };

  const renderOtpLoginSection = (type, memberType, redirectPath, onBack) => (
    <div>
      <h2 style={{ color: "#007bff" }}>{type} Login (OTP)</h2>
      {!otpSent ? (
        <>
          <input
            className="form-control mobilenumber_input"
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            placeholder="Enter Mobile Number"
            value={mobile}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/\D/g, "");
              setMobile(onlyNums);
            }}
            maxLength={10}
            style={{
              padding: "10px",
              fontSize: "16px",
              width: "70%",
              margin: "auto",
            }}
          />
          <br />
          <button
            onClick={() => sendOTP(memberType)}
            type="button"
            className="btn btn-primary"
            disabled={otpLoading}
          >
            {otpLoading ? "Sending OTP..." : "Send OTP"}
          </button>
        </>
      ) : (
        <>
          <p style={{ marginTop: "10px" }}>
            Enter the OTP sent to +91 {mobile}
          </p>
          <div className="otp_input_box">
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              shouldAutoFocus
              renderInput={(props) => (
                <input
                  {...props}
                  style={{
                    width: "40px",
                    height: "40px",
                    margin: "5px",
                    fontSize: "20px",
                    textAlign: "center",
                    backgroundColor: "#d7dbdd",
                    color: "#273746",
                    border: "none",
                    outline: "none",
                    borderRadius: "5px",
                  }}
                  onFocus={(e) => {
                    e.target.style.backgroundColor = "white";
                    e.target.style.border = "2px solid #007bff";
                  }}
                  onBlur={(e) => {
                    e.target.style.backgroundColor = "#d7dbdd";
                    e.target.style.border = "none";
                  }}
                />
              )}
            />
          </div>
          <button
            onClick={() => verifyOTPHandler(redirectPath)}
            className="btn btn-primary mt-3"
          >
            Verify OTP
          </button>
          {resendDisabled ? (
            <p className="otp_timmer mt-2">
              Resend OTP in <b>{timer}s</b>
            </p>
          ) : (
            <button
              onClick={() => sendOTP(memberType)}
              className="btn btn-outline-primary mt-2"
            >
              Resend OTP
            </button>
          )}
        </>
      )}
      <br />
      <button onClick={onBack} className="btn btn-link mt-3">
        Back to Admin Login
      </button>
    </div>
  );

  return (
    <div className="bg-image">
      <div className="root_box_otp">
        <div className="sub_box2">
          <div className="otp_gif">
            <DotLottieReact
              src="https://lottie.host/769d8a28-d3d5-4a08-96fb-65c2a76321d1/L6L5IWohWv.lottie"
              autoplay
              loop
              style={{ width: "260px", height: "240px" }}
            />
          </div>
          {Partnervisible ? (
            renderOtpLoginSection("Partner", 4, "/dashboard", () =>
              setPartnervisible(false)
            )
          ) : Companyvisible ? (
            renderOtpLoginSection("Company", 2, "/dashboard", () =>
              setCompanyvisible(false)
            )
          ) : (
            <div className="root_amain_admin">
              <h2 style={{ color: "#007bff" }}>Admin Login</h2>
              <p>Enter your Username & Password</p>
              <input
                className="form-control mobilenumber_input_q"
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />

              <input
                className="form-control mobilenumber_input_q mt-2"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {loginErrorMsg && (
                <div
                  style={{
                    color: "red",
                    marginTop: "10px",
                    textAlign: "center",
                  }}
                >
                  {loginErrorMsg}
                  <p style={{ fontSize: "10px", color: "gray" }}>
                    Please check your credentials.
                  </p>
                </div>
              )}
              <br />
              <button
                onClick={handleLogin}
                className="btn btn-primary btn_login"
                disabled={loading}
              >
                <Login size="20" color="white" />{" "}
                {loading ? "Logging in..." : "Login"}
              </button>
              <br />
              <br />
              <button
                onClick={() => setCompanyvisible(true)}
                className="btn btn-primary btn_login"
              >
                Login As A Company
              </button>
              <br />
              <br />
              <button
                onClick={() => setPartnervisible(true)}
                className="btn btn-primary btn_login"
              >
                Login As A Merchant
              </button>
              <div
                className="mt-3 btn-link"
                onClick={() => {
                  navigate("/");
                }}
              >
                <p style={{ fontSize: "15px" }}>Click if you're new here </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
